import React from 'react';

const DropdownArrowIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    fill: "currentColor"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.496 9.7l-5.43 5.176a.208.208 0 0 0 0 .304l.48.457a.234.234 0 0 0 .319 0l6.069-5.785a.21.21 0 0 0 0-.304l-6.07-5.785a.234.234 0 0 0-.319 0l-.479.457a.208.208 0 0 0 0 .304l5.43 5.176z",
      transform: "rotate(90 9.5 9.7)"
    }
  )
);

export { DropdownArrowIcon as default };
//# sourceMappingURL=DropdownArrowIcon.js.map
